//функционал сообщений alert`ов
function show_alert(text, type, time, scroll) {
    var scroll = scroll || true;
    var text = text || '';
    var type = type || 'info';
    $('.alert-message').fadeOut(500, function () {
        setTimeout(function () {
            $('.alert-message .text-info').html(text);
            $('.alert-message').attr('class', 'alert-message ' + type).fadeIn(500).css('display', 'table');
        }, 100);
        if (time) {
            setTimeout(function () {
                fade_alert();
            }, time);
        }
    });
}
function fade_alert() {
    $('.alert-message').fadeOut('fast', function () {
        $('.alert-message .text-info').html('');
        $('.alert-message').attr('class', 'alert-message');
    });
}
function openYoutube(youtube_video) {
    $('#screen').show();
    $('#screen .c-popup').show();

    if (youtube_video) {
        $("#player_no_video").hide();
        $("#player").show();
        var src;
        
        src = "https://www.youtube.com/embed/" + youtube_video + "?rel=0&vq=hd720&border=0&autohide=1&fs=1&enablejsapi=1&autoplay=1&cc_load_policy=1&playsinline=0";
         
        var div = document.getElementById("player");

        div.getElementsByTagName("iframe")[0].src = src;
        div.getElementsByTagName("iframe")[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');

    } else {
        $("#player_no_video").css('display', 'table');
        $("#player").hide();
    }
}

function openYoutubeStart(youtube_video) {
    $('#screen').show();
    $('#screen .c-popup').show();

    if (youtube_video) {
        $("#player_no_video").hide();
        $("#player").show();
        var src;
        
        src = "https://www.youtube.com/embed/" + youtube_video + "?start=53&rel=0&vq=hd720&border=0&autohide=1&fs=1&enablejsapi=1&autoplay=1&cc_load_policy=1&playsinline=0";
         
        var div = document.getElementById("player");

        div.getElementsByTagName("iframe")[0].src = src;
        div.getElementsByTagName("iframe")[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');

    } else {
        $("#player_no_video").show();
        $("#player").hide();
    }
}

function closeYoutube() {
    $(window).trigger('magi.hypnos.videoClose');
    if ($("#player:visible")) {
        document.getElementById("player").getElementsByTagName("iframe")[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');        
    }
    
    document.getElementById("player").getElementsByTagName("iframe")[0].src = '';

    $('#player').hide();
    $('#player_no_video').hide();
    $('#screen').fadeOut();
}

fotoramaInit();

//$(window).load(function () {
//    var video = document.getElementById('video');
//    video.play();
//});

$(document).ready(function () {
    //play audio
    var audio = document.getElementById('audio');

    function togglePause() {
        if (audio.paused && audio.currentTime > 0 && !audio.ended || audio.currentTime == 0) {
         audio.play();
        } else {
         audio.pause();
        }
    }
    $(document).on('click', '#a_play', function(){
        $(window).trigger('hypnos.audioClick');
        togglePause();
    });
    
    $('#audio').on('click', function(){
        $(window).trigger('hypnos.audioClick');
    });

    //play video
    var video = document.getElementById('video');
    var play = document.getElementById('play');

    video.play();

    play.addEventListener('click',function(){
      video.play();
    },false);
       
    var owl = $('.owl-carousel');

    owl.owlCarousel({
        items:1,
        nav: true,
        dots: true,
        loop: true,
        mouseDrag: false,
        touchDrag: false
    });
    owl.on('initialized.owl.carousel', function(event) {
        video.play();
    });
    owl.on('changed.owl.carousel', function(event) {
        video.play();
        $('.owl-dot').each(function(i){
            var itemNum = ++i;
            $(this).attr('id', 'feature-slide' + itemNum);
        });
        // $(document).on('click', '#a_play', function(){
        //     togglePause();
        // });
    });

    // аналитика слайды фич
    $('.owl-dot, .owl-next, .owl-prev').on('click', function(){
        setTimeout(function(){
            var feature = $('.owl-dot.active').attr('id');
            return true;
        }, 100);
    });

    $(document).on('click', '.close-alert', function () {
        $(this).parents('.alert-message').fadeOut();
    });
    $('.notify-me-button').click(function (e) {
        e.preventDefault();
        var me = this;
        var form = $(me).parent('.notify-box-button');

        var email = $(form).find('input[name=email]').val() || null;
        var access_beta = false;
        var type = $(form).find('input[name=type]').val();
        var object = $(form).find('input[name=object]').val();
        var subscribe_page = window.location.href;

        $.ajax({
            url: '/api/v1/auth/notify-me',
            type: 'POST',
            dataType: "json",
            data: {'email': email, 'subscribe_page': subscribe_page, 'object': object, 'type': type, access_beta: access_beta},
            success: function (data) {
                switch (data.status) {
                    case 'success':
                        $('.desktop .c-popup').fadeOut();
                        $('.tablet .c-popup, .mobile .c-popup').hide();
                        $(form).removeClass('active');
                        $(form).find('input[name=email]').val('');
                        show_alert(data.message, 'success');
                        $(window).trigger('landing.notify');
                        break;
                    case 'error':
                        show_alert(data.message, 'error');
                        break;
                    case 'exists':
                        $(form).removeClass('active');
                        $('.desktop .c-popup').fadeOut();
                        $('.tablet .c-popup, .mobile .c-popup').hide();
                        $(form).find('input[name=email]').val('');
                        show_alert(data.message, 'info');
                        break;
                    default:
                        show_alert('error', 'error');
                }
            }
        });
    });
    $('.scroll').bind("click", function (e) {
        var anchor = $(this);
        var name = anchor.attr('href').replace(new RegExp("#", 'gi'), '');
        var $obj = $('a[data-name=' + name + ']');
        if ( $obj.length == 0 ){
            $obj = $('a[name=' + name + ']');
        }
        $('html, body').stop().animate({
            scrollTop: $obj.offset().top}, 1000);
        e.preventDefault();
        return false;
    });

    $('.andr-app').on('click', function(){
        $(window).trigger('landing.andrApp');
    });
    $('.ios-app').on('click', function(){
        $(window).trigger('landing.iosApp');
    });
    $('.amaz-app').on('click', function(){
        $(window).trigger('landing.amazApp');
    });
    $('.buy-now').on('click', function(){
        $(window).trigger('magi.hypnos.buyNow');
    });
    
    $('.buy-banner').on('click', function(){
        $(window).trigger('magi.hypnos.buyBanner');
    });
    
    $('.learn-more-banner').on('click', function(){
        $(window).trigger('magi.hypnos.moreBanner');
    });
 
});

$(document).on('click', '.get-for-free', function(){
    var redemptionCode = $(this).attr('data-code');
    $('.redemption-code').text(redemptionCode);
    $('.c-popup').fadeIn('slow');
});

$(document).on('click', '.c-close, .yc-return', function(){
    $('.c-popup').fadeOut('slow');
});